// import React, { createContext, useContext, useState, ReactNode } from 'react';
// import {
//     CModal,
//     CModalHeader,
//     CModalTitle,
//     CModalBody,
//     CModalFooter,
//     CButton,
//     CToaster,
//     CToast,
//     CToastHeader,
//     CToastBody,
// } from '@coreui/react-pro';

// // Tipos de color admitidos por CoreUI
// export type NotificationColor =
//     | 'primary'
//     | 'secondary'
//     | 'success'
//     | 'danger'
//     | 'warning'
//     | 'info'
//     | 'brand'; // Personalizado para la marca

// interface ModalConfig {
//     title: string;
//     message: ReactNode;
//     color?: NotificationColor;
//     confirmText?: string;
//     cancelText?: string;
//     onConfirm?: () => void;
// }

// interface ToastConfig {
//     title?: string;
//     message: string;
//     color?: NotificationColor;
//     delay?: number; // Tiempo de visibilidad en milisegundos
// }

// interface NotificationContextType {
//     showModal: (config: ModalConfig) => void;
//     showToast: (config: ToastConfig) => void;
//     hideModal: () => void;
// }

// const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

// export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
//     // Estado para el Modal Central
//     const [modalVisible, setModalVisible] = useState(false);
//     const [modalConfig, setModalConfig] = useState<ModalConfig>({ title: '', message: '' });

//     // Estado para las alertas Toast
//     const [toastList, setToastList] = useState<Array<ToastConfig & { id: number }>>([]);

//     // Métodos de control
//     const showModal = (config: ModalConfig) => {
//         setModalConfig(config);
//         setModalVisible(true);
//     };

//     const hideModal = () => {
//         setModalVisible(false);
//     };

//     const showToast = (config: ToastConfig) => {
//         const id = Date.now();
//         setToastList((prev) => [...prev, { ...config, id }]);
//     };

//     // Ayudante para resolver los colores CSS o clases según la paleta
//     const getHeaderStyle = (color?: NotificationColor) => {
//         if (color === 'brand' || color === 'danger') {
//             return { backgroundColor: '#FE2445', color: '#FFFFFF' };
//         }
//         if (color === 'primary') {
//             return { backgroundColor: '#19202C', color: '#FFFFFF' };
//         }
//         return undefined;
//     };

//     return (
//         <NotificationContext.Provider value={{ showModal, showToast, hideModal }}>
//             {children}

//             {/* MODAL CENTRAL REUTILIZABLE */}
//             <CModal
//                 alignment="center"
//                 visible={modalVisible}
//                 onClose={hideModal}
//                 backdrop="static"
//             >
//                 <CModalHeader
//                     style={getHeaderStyle(modalConfig.color)}
//                     className={modalConfig.color && modalConfig.color !== 'brand' ? `bg-${modalConfig.color} text-white` : ''}
//                 >
//                     <CModalTitle className="fw-bold fs-5">
//                         {modalConfig.title || 'DomicilApp Alerta'}
//                     </CModalTitle>
//                 </CModalHeader>
//                 <CModalBody className="py-4 text-secondary">
//                     {modalConfig.message}
//                 </CModalBody>
//                 <CModalFooter className="border-0">
//                     {modalConfig.cancelText && (
//                         <CButton color="secondary" variant="ghost" onClick={hideModal}>
//                             {modalConfig.cancelText}
//                         </CButton>
//                     )}
//                     <CButton
//                         style={{ backgroundColor: '#19202C', borderColor: '#19202C' }}
//                         className="text-white fw-bold px-4"
//                         onClick={() => {
//                             if (modalConfig.onConfirm) modalConfig.onConfirm();
//                             hideModal();
//                         }}
//                     >
//                         {modalConfig.confirmText || 'Aceptar'}
//                     </CButton>
//                 </CModalFooter>
//             </CModal>

//             {/* TOASTER (FLOTANTE EN ESQUINA SUPERIOR DERECHA) */}
//             <CToaster placement="top-end" className="p-3" style={{ zIndex: 1090 }}>
//                 {toastList.map((toast) => (
//                     <CToast
//                         key={toast.id}
//                         autohide={true}
//                         delay={toast.delay || 4000}
//                         visible={true}
//                         color={toast.color && toast.color !== 'brand' ? toast.color : undefined}
//                         className="shadow-sm border-0 mb-2"
//                         style={toast.color === 'brand' ? { backgroundColor: '#19202C', color: '#FFFFFF' } : undefined}
//                     >
//                         <CToastHeader closeButton className="fw-bold">
//                             <span className="me-auto">{toast.title || 'DomicilApp'}</span>
//                         </CToastHeader>
//                         <CToastBody>{toast.message}</CToastBody>
//                     </CToast>
//                 ))}
//             </CToaster>
//         </NotificationContext.Provider>
//     );
// };

// // Hook personalizado para consumir el contexto fácilmente
// export const useNotification = () => {
//     const context = useContext(NotificationContext);
//     if (!context) {
//         throw new Error('useNotification debe ser utilizado dentro de un NotificationProvider');
//     }
//     return context;
// };

import React, { createContext, useContext, useState, ReactNode } from 'react';
import {
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CButton,
    CToaster,
    CToast,
    CToastBody,
    CToastClose,
} from '@coreui/react-pro';

export type NotificationType = 'success' | 'danger' | 'warning' | 'info' | 'brand';

interface ModalConfig {
    title: string;
    message: ReactNode;
    type?: NotificationType;
    confirmText?: string;
    cancelText?: string;
    onConfirm?: () => void;
}

interface ToastConfig {
    title?: string;
    message: string;
    type?: NotificationType;
    delay?: number;
}

interface NotificationContextType {
    showModal: (config: ModalConfig) => void;
    showToast: (config: ToastConfig) => void;
    hideModal: () => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [modalConfig, setModalConfig] = useState<ModalConfig>({ title: '', message: '' });
    const [toastList, setToastList] = useState<Array<ToastConfig & { id: number }>>([]);

    const showModal = (config: ModalConfig) => {
        setModalConfig(config);
        setModalVisible(true);
    };

    const hideModal = () => setModalVisible(false);

    const showToast = (config: ToastConfig) => {
        const id = Date.now();
        setToastList((prev) => [...prev, { ...config, id }]);
    };

    // Asignador de colores de acento (Borde izquierdo destacado)
    const getAccentColor = (type?: NotificationType) => {
        switch (type) {
            case 'success':
                return '#10B981'; // Verde Esmeralda vibrante
            case 'danger':
                return '#FE2445'; // Rojo DomicilApp
            case 'warning':
                return '#F59E0B'; // Ámbar/Amarillo
            case 'info':
                return '#3B82F6'; // Azul Informativo
            case 'brand':
            default:
                return '#FE2445';
        }
    };

    return (
        <NotificationContext.Provider value={{ showModal, showToast, hideModal }}>
            {children}

            {/* MODAL CENTRAL MODERNO Y DESTACADO */}
            <CModal
                alignment="center"
                visible={modalVisible}
                onClose={hideModal}
                backdrop="static"
                className="border-0"
            >
                <CModalHeader
                    style={{
                        backgroundColor: '#19202C',
                        color: '#FFFFFF',
                        borderBottom: `4px solid ${getAccentColor(modalConfig.type)}`,
                    }}
                    className="py-3 px-4"
                >
                    <CModalTitle className="fw-bold fs-5 d-flex align-items-center gap-2">
                        <span
                            style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                backgroundColor: getAccentColor(modalConfig.type),
                                display: 'inline-block',
                            }}
                        />
                        {modalConfig.title || 'DomicilApp'}
                    </CModalTitle>
                </CModalHeader>
                <CModalBody className="py-4 px-4 text-dark fs-6" style={{ backgroundColor: '#F8FAFC' }}>
                    {modalConfig.message}
                </CModalBody>
                <CModalFooter className="border-0 px-4 pb-3" style={{ backgroundColor: '#F8FAFC' }}>
                    {modalConfig.cancelText && (
                        <CButton
                            color="secondary"
                            variant="ghost"
                            onClick={hideModal}
                            className="fw-semibold text-secondary"
                        >
                            {modalConfig.cancelText}
                        </CButton>
                    )}
                    <CButton
                        style={{ backgroundColor: '#19202C', borderColor: '#19202C' }}
                        className="text-white fw-bold px-4 shadow-sm"
                        onClick={() => {
                            if (modalConfig.onConfirm) modalConfig.onConfirm();
                            hideModal();
                        }}
                    >
                        {modalConfig.confirmText || 'Aceptar'}
                    </CButton>
                </CModalFooter>
            </CModal>

            {/* TOASTER ESTILO PRO (DARK NAVY CON BORDE DE COLOR Y SOMBRA) */}
            <CToaster placement="top-end" className="p-3" style={{ zIndex: 1090 }}>
                {toastList.map((toast) => {
                    const borderAccent = getAccentColor(toast.type);
                    return (
                        <CToast
                            key={toast.id}
                            autohide={true}
                            delay={toast.delay || 4000}
                            visible={true}
                            className="border-0 shadow-lg mb-3 rounded-3 overflow-hidden"
                            style={{
                                backgroundColor: '#19202C',
                                color: '#FFFFFF',
                                borderLeft: `6px solid ${borderAccent}`,
                                minWidth: '320px',
                            }}
                        >
                            <CToastBody className="p-3 d-flex align-items-start justify-content-between">
                                <div className="d-flex align-items-start gap-3">
                                    <div className="mt-1">
                                        {/* Indicador circular Neón */}
                                        <span
                                            style={{
                                                width: '12px',
                                                height: '12px',
                                                borderRadius: '50%',
                                                backgroundColor: borderAccent,
                                                display: 'block',
                                                boxShadow: `0 0 8px ${borderAccent}`,
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-1 text-white" style={{ fontSize: '0.95rem' }}>
                                            {toast.title || 'DomicilApp'}
                                        </h6>
                                        <p className="mb-0 text-white-50" style={{ fontSize: '0.85rem', lineHeight: '1.3' }}>
                                            {toast.message}
                                        </p>
                                    </div>
                                </div>
                                <CToastClose className="btn-close-white ms-2 opacity-75" />
                            </CToastBody>
                        </CToast>
                    );
                })}
            </CToaster>
        </NotificationContext.Provider>
    );
};

export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotification debe ser utilizado dentro de un NotificationProvider');
    }
    return context;
};